<template>
  <div>
    <div>
      <h2 class="mb-4">หนังสือ/บทความ Exporting</h2>
    </div>

    <CRow>
      <CCol col="12">
        <vue-good-table mode="remote" :columns="columns" :rows="rows">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'createdAt'">
              {{ props.row.createdAt | datetimeFormat }}
            </span>
            <span v-else-if="props.column.field == 'action'">
              <CButtonGroup class="m-1">
                <CButton
                  size="sm"
                  color="success"
                  :variant="props.row.exportStatus === 1 ? 'outline' : ''"
                  :disabled="props.row.exportStatus === 1"
                  @click="getFfmpegs(props.row.id)"
                >
                  {{ props.row.exportStatus === 1 ? 'Exporting' : 'Export' }}
                  <span class="sr-only">{{
                    props.row.exportStatus === 1
                      ? 'กำลัง Export หนังสือ'
                      : 'สั่ง Export หนังสือ'
                  }}</span>
                </CButton>
                <CButton
                  size="sm"
                  color="info"
                  :variant="props.row.exportStatus !== 2 ? 'outline' : ''"
                  :disabled="props.row.exportStatus !== 2"
                >
                  <a
                    :href="props.row.downloadUrl"
                    :class="!props.row.downloadUrl ? 'disabled' : ''"
                  >
                    Download
                  </a>
                  <span class="sr-only">ดาวน์โหลดหนังสืออีพับ</span>
                </CButton>
              </CButtonGroup>

              <CButton
                color="info"
                size="sm"
                class="m-1"
                @click="$refs.infoModal.show(props.row.id)"
              >
                <i class="fa fa-info"></i>
                <span class="sr-only">ดูข้อมูลหนังสือ</span>
              </CButton>
            </span>
            <span v-else class="h6">
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </CCol>
    </CRow>

    <BookInfoModal ref="infoModal" />
  </div>
</template>

<script>
import moment from 'moment'

import BookInfoModal from '../modal/BookInfoModal'

import apiBook from '@/apis/book'

export default {
  name: 'Book',
  components: {
    BookInfoModal
  },
  data() {
    return {
      columns: [
        {
          label: 'ลำดับ',
          field: 'no',
          width: '50px',
          thClass: 'text-center',
          tdClass: 'text-center',
          sortable: false
        },
        {
          label: 'ชื่อหนังสือ',
          field: 'name',
          sortable: false,
          width: '180px'
        },
        {
          label: 'ผู้แต่ง',
          field: 'authorName',
          sortable: false,
          width: '150px'
        },
        {
          label: 'ผู้แปล',
          field: 'translatorName',
          sortable: false,
          width: '150px'
        },
        {
          label: 'หมวดหมู่',
          field: 'categoryName',
          sortable: false,
          width: '140px'
        },
        {
          label: 'วันเวลาที่สร้าง',
          field: 'createdAt',
          sortable: false,
          width: '160px'
        },
        {
          label: 'ความสมบูรณ์ (%)',
          field: 'percent',
          sortable: false,
          tdClass: 'text-right',
          width: '140px'
        },
        {
          field: 'action',
          sortable: false,
          tdClass: 'text-center',
          width: '220px'
        }
      ],
      rows: [],
      interval: null
    }
  },
  created() {
    this.getList()

    if (!this.tabInterval) {
      this.tabInterval = setInterval(() => {
        this.getList()
      }, 10000)
    }
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval)
  },
  methods: {
    getList() {
      apiBook
        .getListDownload()
        .then((result) => {
          this.rows = []

          for (let i = 0; i < result.data.length; i++) {
            const item = result.data[i]
            this.rows.push({
              no: i + 1,
              id: item.id,
              name: item.name,
              authorName: item.authorName,
              translatorName: item.translatorName,
              categoryName: item.category.name,
              percent: item.percent,
              createdAt: item.createdAt,
              exportStatus: item.exportStatus,
              downloadUrl: item.downloadUrl
            })
          }
        })
        .catch(() => {
          this.rows = []
        })
    }
  }
}
</script>
